import type {ISketchObject} from '../sketch/ISketchObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图对象协议时返回 true。
 */
export function isSketchObject(value: unknown): value is ISketchObject {
	// 顶层草图对象统一使用 isSketchObject 标记。
	return hasRuntimeFlag(value, 'isSketchObject');
}
